<div class="container">
  <tileset-style-form></tileset-style-form>
  <canvas #canvas height="25"></canvas>
  <canvas #scale height="25"></canvas>
</div>
